import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-3">
            <i className="ri-hashtag text-primary-500 mr-2"></i>
            热门话题标签
          </h2>
          <p className="text-sm text-foreground-600 text-center mb-10">
            当前最火的话题都在这里，点击进入话题吃瓜专区
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-9 gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#topics"
                className="group bg-background-100 rounded-lg p-4 text-center cursor-pointer hover:bg-primary-50 transition-colors no-underline"
              >
                <h3 className="text-sm font-medium text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {topic.name}
                </h3>
                <div className="flex items-center justify-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-0.5 whitespace-nowrap">
                    <i className="ri-fire-line text-accent-500 text-xs"></i>
                    {topic.heat}
                  </span>
                  <span className="flex items-center gap-0.5 whitespace-nowrap">
                    <i className="ri-chat-1-line text-secondary-500 text-xs"></i>
                    {topic.posts}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}